angular
.module('inputCfPiva.components', [])
.component('inputCfPiva', {
	templateUrl: 'ng/components/inputCfPiva/inputCfPiva.html',
	bindings: {
		/** Input data **/
		inputId: '@',
		inputName: '@',
		inputClass: '@',
		formName: '=',
		bindingVariable: '=',
		inputPlaceholder: '@',
		/** Optional data **/
		inputDisableOn: '<'
	},
	controllerAs: 'inputCfPivaCtrl',
	controller: function($translate, validationService) {
		/** not to loose *this reference **/
		var self = this;

		self.validationService = validationService;
        self.$onInit = function () {
        	self.inputDisableOn = self.inputDisableOn || false;

        }

        self.$onChanges = function(){
        }

      self.errorMsgShown = false;
      self.validationService = validationService;

      self.resetAlert = function(){
        self.errorMsgShown = false;
      }

      self.showAlertMsg = function(){
        self.errorMsgShown = !self.errorMsgShown;
      }

	  self.checkCfOrPiva = function () {
		  if (self.bindingVariable.length === 11) {
			self.validationService.checkPiva(self.bindingVariable);
		  } else if (self.bindingVariable.length === 16) {
			self.validationService.checkCf(self.bindingVariable, self.formName, self.inputName);
		  } 
	  }

	}
});
